import { persistor } from 'index';
import React, { forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';

function Menu({ props, forwardedRef, setIsMenuRightVisible }: any) {
  const navigation = useNavigate();

  const nickname = sessionStorage.getItem('nickname');
  const email = sessionStorage.getItem('email');
  const authority = sessionStorage.getItem('authority');

  const purge = async () => {
    await persistor.purge();
  };

  const onLogoutClick = async () => {
    // sessionStorage.removeItem('jwtToken');
    // sessionStorage.removeItem('nickname');
    // sessionStorage.removeItem('email');
    // sessionStorage.removeItem('authority');
    sessionStorage.clear();
    window.dispatchEvent(new Event('storage'));
    setIsMenuRightVisible(false);
    // await setTimeout(() => purge(), 200);
  };
  const onMypageClick = () => {
    setIsMenuRightVisible(false);
    navigation('/mypage');
  };
  const onAdminClick = () => {
    setIsMenuRightVisible(false);
    navigation({
      pathname: '/acupediaAdmin/account',
      search: '?index=1'
    });
  };
  return (
    <div
      {...props}
      ref={forwardedRef}
      className="overflow-hidden pt-[12px] absolute w-[264px] bg-white shadow-xl right-0 rounded-lg mt-9"
    >
      <p className="pl-[22px] text-[13px] font-normal opacity-50 h-[47px] flex items-center">
        메뉴
      </p>
      <div className="pl-[22px] h-[85px] flex flex-col justify-center">
        <p className="text-[17px] font-semibold ">{nickname}</p>
        <p className="text-[15px] font-normal text-[#1992FB]">
          {authority === 'ADMIN'
            ? '관리자'
            : authority === 'DOCTOR'
            ? '한의사'
            : authority === 'STUDENT'
            ? '한의생'
            : '일반회원'}
        </p>
        <p className="text-[15px] font-normal text-[#767676]">{email}</p>
      </div>
      <div
        onClick={onMypageClick}
        className="hover:bg-[#EFEFEF] hover:rounded-lg cursor-pointer h-10 flex items-center"
      >
        <p className="pl-[22px] text-[15px] font-semibold">마이페이지</p>
      </div>
      {authority === 'ADMIN' ? (
        <div
          onClick={onAdminClick}
          className="hover:bg-[#EFEFEF] hover:rounded-lg cursor-pointer h-10 flex items-center"
        >
          <p className="pl-[22px] text-[15px] font-semibold">어드민페이지</p>
        </div>
      ) : null}
      <div
        onClick={onLogoutClick}
        className="hover:bg-[#EFEFEF] hover:rounded-lg cursor-pointer h-10 flex items-center"
      >
        <p className="pl-[22px] text-[15px] font-semibold">로그아웃</p>
      </div>
    </div>
  );
}

export default forwardRef(Menu);
